import { createContext, useContext } from 'react';

export const SidebarSelectionContext = createContext(null);

export function useSidebarSelection() {
  return useContext(SidebarSelectionContext);
}
